var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',[_c('div',{staticClass:"view-wrap",on:{"click":_vm.toggleTextVisibility}},[_c('i',{staticClass:"el-icon-view"}),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showText),expression:"!showText"}],staticClass:"el-icon-minus",style:(_vm.style)})]),_c('span',[_vm._v(_vm._s(_vm.maskedText || '-'))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }